// Returns the value of the service types, there is a dictionary to pass these into in the helpers folder
const ServiceTypes = Object.freeze({
  FUNERAL: 1,
  CREMATION: 2,
  CEMETARY: 4,
  MONUMENT: 8,
  PRE_NEED: 16,
  PET_CREMATION: 32,
  EVENT_PLANNING: 64,
});

export default ServiceTypes;
